<template>
    <div class="section" :class="input.extraClass">
        <span class="headline">
         {{ input.label }}
             <template v-if="input.helper">
                <div class="helper">
                    <img src="/images/icon.questionmark.svg" />
                    <p>{{ input.helper }}</p>
                </div>
            </template>
        </span>
        <div :class="input.grid" class="inner grid-50w">
            <template v-for="sectionInput in input.forms">
                <template v-if="sectionInput.type === 'section'">
                    <Section :input="sectionInput" :formValue="formValue"></Section>
                </template>
                <template v-else>
                    <InputField :input="sectionInput" :formValue="formValue"></InputField>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
    import InputField from "./InputField.vue"
    
    export default {
        components: {            
            InputField,
        },
        name: "Section",
        props: {
            input: {
                type: Object,
                required: true
            },
            formValue: {
                type: Object,
                required: false
            }
        },
        mounted () {

        },
        methods: {
        }
    }
</script>